import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { PspPartnerFormValues, PspPartnerItem } from '../../types';
import { pspApi } from '../services';

export interface BankAndPspItemFormState {
  formValues?: PspPartnerFormValues;
  bankId?: string;
}

const initialState: BankAndPspItemFormState = {};

export const bankAndPspItemFormSlice = createSlice({
  name: 'bankAndPspItemForm',
  initialState,
  reducers: {
    clearBankAndPspItemFormState: (state) => {
      state.formValues = undefined;
      state.bankId = undefined;
    },
  },
  extraReducers: (builder) => {
    builder.addMatcher(
      pspApi.endpoints.getPspPartner.matchFulfilled,
      (state, action: PayloadAction<{ data: PspPartnerItem }>) => {
        state.formValues = {
          partnerType: action.payload.data.partnerType,
          location: action.payload.data.location,
          countryId: action.payload.data.countryId,
          paymentsTypes: action.payload.data.paymentsTypes,
          companyName: action.payload.data.companyName,
          legalName: action.payload.data.legalName,
          swift: action.payload.data.swift,
          address: action.payload.data.address,
          managerContacts: action.payload.data.managerContacts,
          onlineBankLink: action.payload.data.onlineBankLink,
          description: action.payload.data.description,
          active: action.payload.data.active,
          sortCode: action.payload.data.sortCode,
          intermediaryBankName: action.payload.data.intermediaryBankName,
          intermediaryBankSwift: action.payload.data.intermediaryBankSwift,
          accountOfCorrespondentWithIntermediaryBank:
            action.payload.data.accountOfCorrespondentWithIntermediaryBank,
          beneficiary: action?.payload?.data?.beneficiary,
          exportFileType: action?.payload?.data?.exportFileType,
          caspId: action?.payload?.data?.caspId,
          aba: action?.payload?.data?.aba,
        };
      },
    );
  },
});

export const { clearBankAndPspItemFormState } = bankAndPspItemFormSlice.actions;

export default bankAndPspItemFormSlice.reducer;
